/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Mode de calcul d'un frais quand le contrat porte sur un parc de biens.
 * @export
 */
export const ModeCalculFraisParc = {
    /**
    * Le frais est compté une seule fois pour l&#39;ensemble du parc
    */
    UneFoisParParc: 1,
    /**
    * Le frais est calculé pour chaque bien puis sommé (défaut)
    */
    ParBien: 2
} as const;
export type ModeCalculFraisParc = typeof ModeCalculFraisParc[keyof typeof ModeCalculFraisParc];


export function instanceOfModeCalculFraisParc(value: any): boolean {
    for (const key in ModeCalculFraisParc) {
        if (Object.prototype.hasOwnProperty.call(ModeCalculFraisParc, key)) {
            if (ModeCalculFraisParc[key as keyof typeof ModeCalculFraisParc] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ModeCalculFraisParcFromJSON(json: any): ModeCalculFraisParc {
    return ModeCalculFraisParcFromJSONTyped(json, false);
}

export function ModeCalculFraisParcFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModeCalculFraisParc {
    return json as ModeCalculFraisParc;
}

export function ModeCalculFraisParcToJSON(value?: ModeCalculFraisParc | null): any {
    return value as any;
}

export function ModeCalculFraisParcToJSONTyped(value: any, ignoreDiscriminator: boolean): ModeCalculFraisParc {
    return value as ModeCalculFraisParc;
}

